import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
//import cookies from 'vue-cookies'
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    users: [],
    clients: [],
    clientsByCode: {},
    varietals: [],
    vintages: [],
    vineyards: [{}],
    facilities: [],
    appellations: [],
    tanks: [],
    tbins: [],
    portatanks: [],
    bblFerms: [],
    presses: [],
    regions: [],
    lotsUpdated: true, // this is toggled once we get a set of lots back based on a change to client or vintage
    // This will be listened to by code that needs to react once this data is loaded
    lot: {
      volume: null,
      remaining: null
    },
    lotsForVintage: [], // Lots for a specific vintage
    allLotsForClient: [],
    allActiveLotsForClient: [],
    gotoLotsPage: false,
    testTable: [
      {
        data: 'abc',
        lotNumber: 'lotsTableLotNumber',
        id: '999'
      }
    ],
    user: null,
    vintage: '',
    tableView: true,
    momentDateFormat: 'll',
    client: { CODE: '', clientid: '' },
    loadingLots: false,
    authenticatedUser: null
  },
  actions: {
    clearUser ({ commit }) {
      commit('clearUser')
    },
    loginUser ({ commit }, payload) {
      firebase.auth().signInWithEmailAndPassword(payload.email, payload.password)
        .then(user => {
          commit('setUser', user)
        })
    },
    registerUser ({ commit }, payload) {
      firebase.auth().createUserWithEmailAndPassword(payload.email, payload.password)
        .then(user => {
     //     cookies.remove('client') // this is more for initial testing. most users won't register multiple user accounts
          // if they do, the initial registration when confirmed will allow the first client to be display
          firebase.firestore().collection('users').add({
            email: payload.email,
            username: payload.username
          })
          commit('setUser', user)
        })
    }
  },
  getters: {
    authenticatedUser (state) {
      return state.authenticatedUser
    },
    user (state) {
      return state.user
    }
  },
  mutations: {
    addVineyard (state, newVineyard) {
      state.vineyards.push(newVineyard)
    },
    clearUser (state) {
      state.authenticatedUser = null
      state.user = null
    },
    setUser (state, payload) {
      state.authenticatedUser = payload
    },
    updateAssets: state => {
      axios
        .get(
          process.env.VUE_APP_BACKEND+'assets?assetClassification=presses'
        )
        .then((response) => {
          state.presses = response.data.data
        })
      axios
        .get(
          process.env.VUE_APP_BACKEND+'assets?assetClassification=bblFerms'
        )
        .then((response) => {
          state.bblFerms = response.data.data
        })
      axios
        .get(
          process.env.VUE_APP_BACKEND+'assets?assetClassification=tanks'
        )
        .then((response) => {
          state.tanks = response.data.data
        })
      axios
        .get(
          process.env.VUE_APP_BACKEND+'assets?assetClassification=t_bins'
        )
        .then((response) => {
          state.tbins = response.data.data
        })
      axios
        .get(
          process.env.VUE_APP_BACKEND+'assets?assetClassification=porta_tanks'
        )
        .then((response) => {
          state.portatanks = response.data.data
        })
    },
    updateVarietals: state => {
      axios
        .get(
          process.env.VUE_APP_BACKEND+'varietals'
        )
        .then((response) => {
          state.varietals = response.data.data
        })
    },
    updateClients: (state, clients) => {
      // this is called to update clients when not staff
      state.clients = clients
      // if (this.$cookies.isKey('client')) {
      //   state.client = this.$cookies.get('client')
      // } else {
        state.client = clients[0]
//      }
      state.clients.forEach(function (client) {
        state.clientsByCode[client['CODE']] = client
      })
    },
    loadAllClients: state => {
      axios
        .get(process.env.VUE_APP_BACKEND+'clients?active=YES')
        .then((response) => {
          state.clients = response.data.data
          // if (cookies.isKey('client')) {
          //   state.client = cookies.get('client')
          // } else {
            state.client = response.data.data[0]
  //        }
          state.clients.forEach(function (client) {
            state.clientsByCode[client['CODE']] = client
          })
        })
    },
    updateVineyards: state => {
      axios
        .get(process.env.VUE_APP_BACKEND+'locations?locationType=Vineyard&clientId='+state.client.clientid)
        .then((response) => {
          state.vineyards = response.data.data
        })
    },
    updateFacilities: state => {
      axios
        .get(process.env.VUE_APP_BACKEND+'locations?type=Facility')
        .then((response) => {
          state.facilities = response.data.data
        })
    },
    updateUser: (state, user) => {
      state.user = user
    },
    updateUsers: state => {
      axios
        .get(process.env.VUE_APP_BACKEND+'users?active=YES')
        .then((response) => {
          state.users = response.data.data
        })
    },
    updateVintages: state => {
      axios
        .get(
          process.env.VUE_APP_BACKEND+'lots?uniqueVintages=1&clientcode=' +
          state.client.CODE
        )
        .then((response) => {
          state.vintages = response.data.data
          if (state.vintage == "") {
            state.vintage = state.vintages[0]
          }
        })
    },
    updateAppellations: state => {
      axios
        .get(
          process.env.VUE_APP_BACKEND+'appellations'
        )
        .then((response) => {
          state.appellations = response.data.data
        })
    },
    updateRegions: state => {
      axios
        .get(
          process.env.VUE_APP_BACKEND+'zones'
        )
        .then((response) => {
          state.regions = response.data.data
        })
    },
    updateLots: state => {
      state.loadingLots = true
      axios
        .get(
          process.env.VUE_APP_BACKEND+'lots?clientcode=' +
              state.client.CODE
        )
        .then((response) => {
          state.allLotsForClient = JSON.parse(JSON.stringify(response.data.data))
          state.allLotsForClient.forEach((lot: {volume: 0, remaining : 0}) => {
            lot.volume = 0
            lot.remaining = 0
          })
          state.allActiveLotsForClient = state.allLotsForClient.filter((item : any) => {
            return item.isActive
          })
          state.lotsForVintage = state.allLotsForClient.filter((item : any) => {
            return state.vintage === item.year
          })
          state.loadingLots = false
          state.lotsUpdated = !state.lotsUpdated
        })
    }
  }
})
